var render, staticRenderFns
import script from "./PieChart.ts?vue&type=script&lang=ts&"
export * from "./PieChart.ts?vue&type=script&lang=ts&"
import style0 from "@/modules/Dashboards/AdminDashboard/AdminDashboard.scss?vue&type=style&index=0&id=66bb3026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bb3026",
  null
  
)

export default component.exports